import React, { useState } from "react";
import { ChevronDown } from 'lucide-react';

const FilterSection = ({ title, children, defaultOpen = false }) => {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className="filter-section">
            <button
                className="filter-section__header"
                onClick={() => setOpen(!open)}
            >
                <span>{title}</span>
                <ChevronDown size={16} className={`filter-section__arrow ${open ? 'open' : ''}`} />
            </button>

            <div className={`filter-section__content ${open ? 'open' : ''}`}>
                <div className="filter-section__content-inner">{children}</div>
            </div>
        </div>
    );
};
export default FilterSection;
